module.exports = __webpack_public_path__ + "img/home1-5.419fdd2b.jpg";